import Test from "./modules/Test";
// import { Fancybox } from "@fancyapps/ui";

const test = new Test();
test.showQuestion()

Fancybox.bind('[data-fancybox="inline"]', {
    l10n: {
      CLOSE: "閉じる",
      NEXT: "次",
      PREV: "前",
    },
    on: {
        done: () => {
            const scroll_to_top = () => {
                document.querySelector('.fancybox__content').scroll({top: 0, behavior: 'smooth'});
            }
            document.querySelector('.is-prev').addEventListener( 'click' , scroll_to_top );
            document.querySelector('.is-next').addEventListener( 'click' , scroll_to_top );
        },
    }
});

const shoplist_game = document.querySelectorAll('.js-accordion-shoplist');
const shoplistAccordion_game = () => {
    shoplist_game.forEach(shop => {
        $(shop).on('click', function () {
            $(this).toggleClass('isOpen');
            $(this).next().slideToggle();
        })
    });
}

window.addEventListener('load', () => {
    shoplistAccordion_game();
})

